import { Link } from 'react-router-dom';
import { NudosHoverText } from '../../../../components/NudosComponents';
import { capitalize } from '../../../../utils/truncateText';
import './LogisticServiceListingCard.scss';

interface IoriginCountry {
  id: number;
  code: string;
  name: string;
  flag: string;
}

interface IdestinationCountry {
  id: number;
  code: string;
  name: string;
  flag: string;
}

export interface IlogisticServiceListingCardData {
  originCountry: IoriginCountry;
  destinationCountry: IdestinationCountry;
  organizationName: string;
  id: number;
  origin: string;
  destination: string;
  status: string;
  additionalServices: string[];
  userComments: string;
  backofficeComments: string;
  provider: string;
  price: number;
}

const LogisticServiceListingCard = ({
  logisticServiceData
}: {
  logisticServiceData?: IlogisticServiceListingCardData;
}) => {
  const originCode = logisticServiceData?.originCountry?.code;
  const destinationCode = logisticServiceData?.destinationCountry?.code;
  const originFlag = logisticServiceData?.originCountry?.flag;
  const destinationFlag = logisticServiceData?.destinationCountry?.flag;

  const logisticDetailsRedirection = {
    pathname: `/logistic-service/details/${logisticServiceData?.id}`,
    state: {
      originUrl: '/logistic-service/listing',
      originText: 'Volver al servicio logístico'
    }
  };

  const countryValue =
    originCode && destinationCode ? (
      <div className="countryValue">
        <div className="flag" style={{ backgroundImage: `url(${originFlag})` }} />
        {originCode}
        /
        <div className="flag" style={{ backgroundImage: `url(${destinationFlag})` }} />
        {destinationCode}
      </div>
    ) : (
      'N/A'
    );

  return (
    <div className="LogisticServiceListingCard">
      <div className="LogisticServiceCardContainer">
        <div className="LogisticServiceColumn country">{countryValue}</div>
        <NudosHoverText
          customClassName="LogisticServiceColumn business"
          charactersLimit={9}
          onlyIfTruncated
          text={logisticServiceData?.organizationName || 'N/A'}
        />
        <Link to={logisticDetailsRedirection} className="LogisticServiceColumn id">
          <div>{logisticServiceData?.id || 'N/A'}</div>
        </Link>
        <div className="LogisticServiceColumn origin">{logisticServiceData?.origin || 'N/A'}</div>
        <div className="LogisticServiceColumn destination">{logisticServiceData?.destination || 'N/A'}</div>
        <NudosHoverText
          customClassName="LogisticServiceColumn state"
          charactersLimit={7}
          text={(logisticServiceData?.status && capitalize(logisticServiceData?.status)) || 'N/A'}
          onlyIfTruncated
        />
        <div className="LogisticServiceColumn services">
          {!!logisticServiceData?.additionalServices?.length
            ? logisticServiceData?.additionalServices.map(service => <div>{service}</div>)
            : 'N/A'}
        </div>
        <div className="LogisticServiceColumn comments">{logisticServiceData?.userComments || 'N/A'}</div>
        <div className="LogisticServiceColumn notes">{logisticServiceData?.backofficeComments || 'N/A'}</div>
        <NudosHoverText
          customClassName="LogisticServiceColumn provider"
          charactersLimit={14}
          onlyIfTruncated
          text={logisticServiceData?.provider || 'N/A'}
        />
        <div className="LogisticServiceColumn price">{logisticServiceData?.price || 'N/A'}</div>
      </div>
    </div>
  );
};

export default LogisticServiceListingCard;
